import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'

const GuildNews = () => {
  const { guildReference } = useGuild()

  return (
    <Section title={`News | ${guildReference?.name}`}>
      GuildNews! {guildReference?.id}
    </Section>
  )
}

export default GuildNews
